import { Button, Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { useMealCreditFormSubmit } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/useMealCreditFormSubmit';
import { useManageMealCreditForm } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/useManageMealCreditForm';
import { Rules } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/Rules';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import { MealCreditNameInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/MealCreditNameInput';

interface MealCreditFormProps {
  onAddMealCreditSuccess?: ({ id }: { id: string }) => Promise<void>;
  onAddMealCreditError?: (
    error: IErrorResponse | SdkErrorResponse
  ) => Promise<void>;
  onUpdateMealCreditSuccess?: () => Promise<void>;
  onUpdateMealCreditError?: (
    error: IErrorResponse | SdkErrorResponse
  ) => Promise<void>;
}

export function MealCreditForm({
  onAddMealCreditError,
  onUpdateMealCreditSuccess,
  onAddMealCreditSuccess,
  onUpdateMealCreditError,
}: MealCreditFormProps): JSX.Element {
  useManageMealCreditForm();

  const { handleSubmit, formState, getValues } =
    useFormContext<IMealCreditFormFields>();
  const { isSubmitting, isValid } = formState;

  const { onFormSubmit: onMealCreditFormSubmit } = useMealCreditFormSubmit({
    onAddMealCreditError,
    onUpdateMealCreditSuccess,
    onAddMealCreditSuccess,
    onUpdateMealCreditError,
  });

  async function onFormSubmit(): Promise<void> {
    await onMealCreditFormSubmit({
      // The values passed to the submit function do not include disabled fields.
      // We need to use getValues to retrieve all field values.
      values: getValues(),
    });
  }

  return (
    <form
      onSubmit={(e: React.FormEvent): void => {
        e.preventDefault();
      }}
    >
      <Stack y="lg">
        <Row gutter={12}>
          <Column phone={3} gutter={12}>
            <MealCreditNameInput id="name" name="name" />
          </Column>
        </Row>
      </Stack>

      <Stack y="md">
        <Rules />
      </Stack>
      <Row>
        <Column phone={12}>
          <Button
            type="button"
            isLoading={isSubmitting}
            variant="primary"
            buttonSize="medium"
            disabled={isSubmitting || !isValid}
            onClick={handleSubmit(onFormSubmit)}
          >
            Save meal credit
          </Button>
        </Column>
      </Row>
    </form>
  );
}
